import(/* webpackMode: "eager" */ "/codebuild/output/src2148857912/src/tenant-portal/src/app/page.tsx")